import { ArrowRight } from "lucide-react";
import { useMemo, useState } from "react";
import { SectionTitle } from "../../components/common/SectionTitle";
import { services } from "../../data/siteData";
import { formatCurrency } from "../../utils/formatters";

const DURATION_LABELS = { "2h": "2 hr", "4h": "4 hr", "6h": "6 hr", "8h": "8 hr" };

export function ServicesSection({ onBookService }) {
  const [activeCategory, setActiveCategory] = useState("All");

  const categories = useMemo(
    () => ["All", ...new Set(services.map((s) => s.category))],
    [],
  );

  const filtered = activeCategory === "All"
    ? services
    : services.filter((s) => s.category === activeCategory);

  return (
    <section id="services" className="site-section site-section--soft">
      <div className="container">
        <SectionTitle subtitle="Our Services" title="Curated Experiences" />

        <div className="chip-row scroll-reveal">
          {categories.map((cat) => (
            <button
              key={cat}
              className={activeCategory === cat ? "chip chip--active" : "chip"}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        <p className="services-booking-note scroll-reveal">
          Appointments are booked and paid for by phone or email.
        </p>

        <div className="card-grid card-grid--services">
          {filtered.map((service) => (
            <div
              key={service.id}
              className="content-card"
              style={{ display: "flex", flexDirection: "column" }}
            >
              {/* Header */}
              <div className="content-card__header">
                <div>
                  <p className="eyebrow">{service.category}</p>
                  <h3 className="content-card__title">{service.name}</h3>
                </div>
                <div style={{ textAlign: "right" }}>
                  <p className="price-tag">{formatCurrency(service.price)}</p>
                  {service.duration ? (
                    <p style={{ fontSize: "0.72rem", opacity: 0.5, marginTop: "2px" }}>
                      {DURATION_LABELS[service.duration]}
                    </p>
                  ) : null}
                </div>
              </div>

              <p className="body-copy">{service.description}</p>

              {/* Book button — pushed to bottom */}
              <div style={{ marginTop: "auto", paddingTop: "1rem" }}>
                <button
                  type="button"
                  className="button button--primary"
                  style={{ width: "100%", justifyContent: "center" }}
                  onClick={() => onBookService(service)}
                  aria-label={`Book ${service.name}`}
                >
                  Book <ArrowRight size={14} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
